import { observer } from 'mobx-react-lite'
import { useEffect, useRef, useState } from 'react'
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline'

import { ToggleColorScheme } from './ToggleColorScheme'
import { ChangeTenantAccess } from './ChangeTenantAccess'
import { SwitchLanguage } from './SwitchLanguage'
import { DebugOptions } from './DebugOptions'

export const AppDebugBar = observer(() => {
    const ref = useRef<HTMLDivElement | null>(null)

    const [open, setOpen] = useState(false)

    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setOpen(false)
            }
        }
        document.addEventListener('click', handleClickOutside, true)
        return () => {
            document.removeEventListener('click', handleClickOutside, true)
        }
    }, [])

    return (
        <div
            ref={ref}
            className="fixed bottom-0 right-0 mb-32 mr-0 rounded-l-sm bg-red-500 shadow-lg lg:mb-10"
            style={{ zIndex: 999999 }}
        >
            <div className="relative flex items-center">
                {open && (
                    <>
                        <ToggleColorScheme />
                        <SwitchLanguage />
                        <ChangeTenantAccess />
                        <DebugOptions />
                    </>
                )}
                <div className="py-2 text-white hover:bg-white/10 active:bg-black/20" onClick={() => setOpen(!open)}>
                    {open ? <ChevronRightIcon className="h-5 w-3" /> : <ChevronLeftIcon className="h-5 w-3" />}
                </div>
            </div>
        </div>
    )
})
